import { GradientDTO, TQrDesign } from '@/generator/client'

export const replaceQrColors = (
	qrDesign: TQrDesign,
	newColor: string,
): TQrDesign => {
	const replaceGradient = (gradient?: GradientDTO): GradientDTO | undefined => {
		if (!gradient) return undefined
		return {
			...gradient,
			colorStops: gradient.colorStops.map((cs) => ({
				...cs,
				color: newColor,
			})),
		}
	}

	return {
		...qrDesign,
		dotsOptions: {
			...qrDesign.dotsOptions,
			color: newColor,
			gradient: replaceGradient(qrDesign.dotsOptions.gradient),
		},
		cornersSquareOptions: {
			...qrDesign.cornersSquareOptions,
			color: newColor,
			gradient: replaceGradient(qrDesign.cornersSquareOptions.gradient),
		},
		cornersDotOptions: {
			...qrDesign.cornersDotOptions,
			color: newColor,
			gradient: replaceGradient(qrDesign.cornersDotOptions.gradient),
		},
	}
}
